import API from './Api';

export type SocialAuthPayload = {
  username: string;
  password: string;
};

export const socialRegister = (data: SocialAuthPayload) =>
  API.makePostRequest('/auth/social-register', {
    username: data.username.trim(),
    password: data.password,
  });

export const socialLogin = (data: SocialAuthPayload) =>
  API.makePostRequest('/auth/social-login', {
    username: data.username.trim(),
    password: data.password,
  });
